<template>
  <div id="app">
    <v-header :name="name" :onoff="onoff" v-on:loginFn="loginFn"></v-header>
    <router-view v-on:changeState="changest" v-on:forget="forget"></router-view>
    <div class="btm">Copyright © 2015 图灵机器人 All rights Reserved </div>
  </div>
</template>

<script>
  import header from './components/header/header.vue';
  import login from './components/login/login.vue';

  export default {
    data () {
      return {
        loginShow: true,
        name: '欢迎登录',
        onoff: false
      };
    },
    created () {
      if (this.$route.name === 'login') {
        this.onoff = false;
        this.name = '欢迎登录';
        document.getElementsByTagName('title')[0].innerHTML = '登录';
      } else {
        this.onoff = true;
        this.name = '欢迎注册';
        document.getElementsByTagName('title')[0].innerHTML = '注册';
      }
    },
    components: {
      login,
      'v-header': header
    },
    methods: {
      loginFn () {
        this.onoff = !this.onoff;
        if (this.onoff) {
          this.name = '欢迎注册';
          document.getElementsByTagName('title')[0].innerHTML = '注册';
        } else {
          this.name = '欢迎登录';
          document.getElementsByTagName('title')[0].innerHTML = '登录';
        }
      },
      changest () {
        this.name = '欢迎注册';
        this.onoff = true;
        document.getElementsByTagName('title')[0].innerHTML = '注册';
      },
      forget () {
        this.name = '忘记密码';
        this.onoff = true;
        document.getElementsByTagName('title')[0].innerHTML = '忘记密码';
      }
    }
  };
</script>

<style lang="scss" scoped="" type="text/css">
  .btm{text-align: center;font-size: 12px;color: #999;position: fixed;left: 0;right: 0;bottom: 40px;}
</style>



// WEBPACK FOOTER //
// App.vue?2c342a02